var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckRound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.799805 8C0.799805 3.58172 4.38153 0 8.7998 0C13.2181 0 16.7998 3.58172 16.7998 8C16.7998 12.4183 13.2181 16 8.7998 16C4.38153 16 0.799805 12.4183 0.799805 8ZM12.6887 6.70711C13.0793 6.31658 13.0793 5.68342 12.6887 5.29289C12.2982 4.90237 11.665 4.90237 11.2745 5.29289L8.40589 8.16152C8.19621 8.3712 8.08093 8.48538 7.99176 8.56108L7.98162 8.5696L7.97149 8.56108C7.88232 8.48538 7.76704 8.3712 7.55736 8.16152L6.50691 7.11108C6.11639 6.72055 5.48322 6.72055 5.0927 7.11108C4.70217 7.5016 4.70217 8.13476 5.0927 8.52529L6.14314 9.57574L6.16569 9.59829C6.34414 9.77677 6.51792 9.9506 6.67713 10.0858C6.85198 10.2342 7.07387 10.3938 7.36359 10.4879C7.76528 10.6184 8.19797 10.6184 8.59966 10.4879C8.88937 10.3938 9.11127 10.2342 9.28611 10.0858C9.44532 9.9506 9.6191 9.77678 9.79754 9.5983L9.8201 9.57574L12.6887 6.70711Z",
    fill: "#00AB21"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check_round.6879fc361c04c5c3381b597421038e79.svg";